import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './index.css'
import 'aos/dist/aos.css'

createApp(App).mount('#app')
